module.exports = __webpack_public_path__ + "static/media/icon-menu.8f577052.svg";